import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import useAuth from './preorder/hooks/useAuth';

export default ({ component: Component, ...rest }) => {
  const [checkAuthenticated] = useAuth();
  const location = useLocation();
  const { state } = location || {};
  const { isFinishRegister, isConnectPhone } = state || {};

  return (
    <Route
      {...rest}
      render={
      (props) => (checkAuthenticated() && !isFinishRegister && !isConnectPhone ? (
        <Redirect to="/" />
      ) : (
        <Component {...props} />
      ))
    }
    />
  );
};
